import React, { Component } from "react";
import Constants from "Helpers/Constants";
import axios from "axios";
import DataTable from "examples/Tables/DataTable";
import card from "assets/theme/components/card";
import cardContent from "assets/theme/components/card/cardContent";
import init from "Helpers/WindowToken";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { Link, Navigate, redirect } from "react-router-dom";
import { Card, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from "@mui/material";
// import Textarea from "@mui/joy/Textarea";
import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDButton from "components/MDButton";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

export default class AddTopics extends Component {
  state = {
    allJobs: [],
    message: "",
    notification: false,
    per_pge: 20,
    page_no: 1,

    redirect: false,
    allSubjects: [],
    topic_name: "",
    testimonial: "",
    subject_id: "",
    search: "",
    ar_enabled: "true",
    agriboost_enabled: "true",
  };

  componentDidMount() {
    this.getAllSubjects();
  }

  getAllSubjects = async () => {
    if (init() === "success") {
      await axios
        .get(
          Constants.getUrls.getAllSubjects + "?search=" + this.state.search + "&limit=1000&page=1"
        )
        .then((resp) => {
          console.log(resp.data.data.docs);
          this.setState({
            allSubjects: resp.data.data.docs,
          });
        });
    }
  };

  handleInput = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    let payload = {
      subject_id: this.state.subject_id,
      topic_name: this.state.topic_name,
      ar_enabled: this.state.ar_enabled === "true",
      agriboost_enabled: this.state.agriboost_enabled === "true",
    };
    // fd.append("content", this.state.testimonial);
    // return;

    console.log(payload);

    if (init() === "success") {
      axios
        .post(Constants.postUrls.createTopic, payload)
        .then((resp) => {
          // console.log(resp);
          this.setState({
            notification: true,
            message: resp.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "", redirect: true });
          }, 3000);
        })
        .catch((err) => {
          this.setState({
            notification: true,
            message: err.response.data.message,
          });
          setTimeout(() => {
            this.setState({ notification: false, message: "" });
          }, 5000);
        });
    }
  };

  render() {
    if (this.state.redirect === true) {
      return <Navigate to="/topics" />;
    } else {
      return (
        <div>
          <div>
            <DashboardLayout>
              <DashboardNavbar />
              <MDBox pt={6} pb={3}>
                <Card>
                  <MDBox
                    mx={2}
                    mt={-3}
                    py={3}
                    px={2}
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                  >
                    <MDTypography variant="h6" color="white">
                      Create Topic
                    </MDTypography>
                  </MDBox>
                  {/* <Grid item sm={4} px={2} align="right">
                    <Link to="/admin/addNewJob">
                      <MDButton variant="contained" size="small" color="primary">
                        Create Job
                      </MDButton>
                    </Link>
                  </Grid> */}
                  <MDBox py={3} px={2}>
                    <form onSubmit={this.handleSubmit}>
                      <Grid container sm={12} spacing={2}>
                        <Grid item sm={6}>
                          <InputLabel>Select Subject</InputLabel>
                          <Select
                            value={this.state.subject_id}
                            onChange={(e) => this.setState({ subject_id: e.target.value })}
                            name="subject_id"
                            label="Select Subject"
                            // style={{
                            //   height: "45px",
                            // }}
                            required
                            style={{ width: "100%", height: "45px", color: "#111" }}
                          >
                            <MenuItem value="">Select Subject</MenuItem>
                            {this.state.allSubjects.length > 0 &&
                              this.state.allSubjects.map((item) => (
                                <MenuItem value={item._id} key={item._id} style={{ color: "#111" }}>
                                  {" "}
                                  {item.subject_name}{" "}
                                </MenuItem>
                              ))}
                          </Select>
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Topic Name</InputLabel>
                          <TextField
                            type="text"
                            // label="Subject Name"
                            name="topic_name"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Enable For AR</InputLabel>
                          <FormControl fullWidth>
                            <Select
                              value={this.state.ar_enabled}
                              onChange={(e) => this.setState({ ar_enabled: e.target.value })}
                              style={{ width: "100%", height: "45px", color: "#111" }}
                            >
                              <MenuItem value="true">Enabled</MenuItem>
                              <MenuItem value="false">Disabled</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item sm={6}>
                          <InputLabel>Enable For AgriBoost</InputLabel>
                          <FormControl fullWidth>
                            <Select
                              value={this.state.agriboost_enabled}
                              onChange={(e) => this.setState({ agriboost_enabled: e.target.value })}
                              style={{ width: "100%", height: "45px", color: "#111" }}
                            >
                              <MenuItem value="true">Enabled</MenuItem>
                              <MenuItem value="false">Disabled</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>

                        {/* <Grid item sm={6}>
                          <TextField
                            type="file"
                            label="Subject Poster"
                            name="subject_poster"
                            focused
                            onChange={(e) => {
                              this.setState({
                                subject_poster: e.target.files[0],
                              });
                            }}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid> */}

                        {/* <Grid item sm={6}>
                          <TextField
                            type="text"
                            label="Testimonial"
                            name="testimonial"
                            onChange={this.handleInput}
                            style={{ width: "100%", height: "100%" }}
                          />
                        </Grid> */}
                      </Grid>

                      <Grid align="left" mt={2}>
                        <MDButton variant="contained" size="small" color="info" type="submit">
                          {this.state.loading ? "Creating..." : "Create"}
                        </MDButton>
                      </Grid>
                    </form>
                  </MDBox>
                  <>
                    <MDSnackbar
                      color="success"
                      icon="notifications"
                      title="AgriQuiz Topics"
                      content={this.state.message}
                      dateTime="Just now"
                      open={this.state.notification}
                      //   close={toggleSnackbar}
                    />
                  </>
                </Card>
              </MDBox>
            </DashboardLayout>
          </div>
        </div>
      );
    }
  }
}
